import { TransportLocationService } from 'src/app/angularJS/services/transport-location/transport-location.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';

export const initialise = () => {
  const getTransportLocations = (transportLocationService: TransportLocationService, userService: UserService, queryBuilder: QueryBuilder, linkBuilder: LinkBuilder, $q: ng.IQService) => {
    if (!userService.selectedSchemes || userService.selectedSchemes.length === 0) {
      const deferred = $q.defer();
      const callbackRef = userService.registerSchemeCallback(() => {
        userService.unregisterCallback(callbackRef);
        const schemeLinks = userService.selectedSchemes.map((selectedScheme) => {
          return linkBuilder.getSchemesLink(selectedScheme.id);
        });

        const query = queryBuilder.newParam().fieldIn('scheme.link', schemeLinks).getParam();
        transportLocationService.getList(1, 15, query).then((response) => {
          deferred.resolve(response);
        });
      });

      return deferred.promise;
    } else {
      const schemeLinks = userService.selectedSchemes.map((selectedScheme) => {
        return linkBuilder.getSchemesLink(selectedScheme.id);
      });
      const query = queryBuilder.newParam().fieldIn('scheme.link', schemeLinks).getParam();
      return transportLocationService.getList(1, 15, query);
    }
  };
  getTransportLocations.$inject = ['transportLocationService', 'userService', 'QueryBuilder', 'LinkBuilder', '$q'];

  angular.module('app.transport-locations-upload').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');
    $stateProvider.state('transport-locations-upload', {
      url: '/transport-locations-upload',
      templateUrl: 'app/angularJS/features/transport-locations/upload/transport-locations-upload.html',
      controller: 'transportLocationsUploadController',
      controllerAs: 'vm',
      parent: 'common',
      resolve: {
        transportLocationsResponse: getTransportLocations
      }
    }).state('transport-locations-publisher', {
      url: '/transport-locations/publish',
      templateUrl: 'app/angularJS/features/transport-locations/upload/publisher/transport-locations-publisher.html',
      controller: 'transportLocationsPublisherController',
      controllerAs: 'vm',
      parent: 'common',
      params: {
        transportLocations: undefined
      }
    });
    $urlRouterProvider.otherwise('/');
  }]);
};